import type EnType from '../en-US/environment';

export default {
  'environment.manageModal.title': 'Gerenciamento de Ambiente',
  'environmentDetail.label.server': 'URL Base',
  'environmentDetail.label.variables': 'Variáveis',
  'environmentDetail.label.variables.tips':
    'Insira {{var_name}} nos valores dos parâmetros para reutilizar valores em diferentes endpoints e parâmetros.',
  'environment.title.variableName': 'Nome',
  'environment.title.variableName.placeholder': 'Adicionar uma nova variável',
  'environment.title.addVariableValue': 'Adicionar Variável',
  'environment.title.value': 'Valor',
  variableNameEmptyError: 'O nome é obrigatório',
  preFixUrl: 'URL de Prefixo',
  'editor.tip': 'O formato de dados segue',
  filedBulkEdit: 'Edição em massa',
  'environment.title.serviceName': 'Nome do Serviço',
  'environment.manageModal.tip':
    'Os dados definidos aqui são armazenados apenas no seu navegador local, não sincronizados para a nuvem.',
  'environment.manageModal.tip.clickToSetVariable': 'Clique para definir a variável: ',
  'baseURL.colon': 'URL Base: ',
  'environment.variable.notSet': 'Não definido',
  byComma: 'Por vírgula',
  byColon: 'Por dois pontos',
} satisfies typeof EnType;
